import React, { useState, useEffect } from 'react'

import { DEI_COLORS } from "../constants"

import DEIPageDonutChart from './DEIPageDonutChart/DEIPageDonutChart'
import DEIPageLegend from '../DEIPageLegend/DEIPageLegend'

import {
  DEIPageDonutChartsDIV,
  DEIPageDonutChartsChartWrapperDIV,
} from './DEIPageDonutCharts.styles'

const RACE_COLORS = [
  DEI_COLORS.PINK,
  DEI_COLORS.YELLOW,
  DEI_COLORS.LIGHT_BLUE,
  DEI_COLORS.BLUE,
  DEI_COLORS.NEUTRAL,
]

const GENDER_COLORS = [
  DEI_COLORS.WHALE_TAIL,
  DEI_COLORS.PURPLE,
  DEI_COLORS.NEUTRAL,
]

const DEIPageDonutCharts = ({ data }) => {
  const [activeDate, setActiveDate] = useState(0)
  const [activeRace, setActiveRace] = useState(null)
  const [activeGender, setActiveGender] = useState(null)

  useEffect(() => {
    setActiveDate(0)
  }, [data])

  const racePercentages = data.race.dates[activeDate] ? data.race.dates[activeDate].percentages : data.race.dates[0].percentages
  const genderPercentages = data.gender.dates[activeDate] ? data.gender.dates[activeDate].percentages : data.gender.dates[0].percentages

  return (
    <DEIPageDonutChartsDIV>
      <select
        className="size--M"
        onChange={e => setActiveDate(e.target.value)}
        value={activeDate}
      >
        {data.race.dates.map(({ title }, i) => (
          <option key={title} value={i}>{title}</option>
        ))}
      </select>
      <DEIPageDonutChartsChartWrapperDIV>
        <h5>{data.race.title}</h5>
        <DEIPageDonutChart
          activePieSliceIndex={activeRace}
          colors={RACE_COLORS}
          id="race"
          percentages={racePercentages}
          setActivePieSliceIndex={i => setActiveRace(i)}
        />
        <DEIPageLegend
          colors={RACE_COLORS}
          filterLegend
          onHoverType={i => setActiveRace(i)}
          types={racePercentages}
        />
      </DEIPageDonutChartsChartWrapperDIV>
      <DEIPageDonutChartsChartWrapperDIV>
        <h5>{data.gender.title}</h5>
        <DEIPageDonutChart
          activePieSliceIndex={activeGender}
          colors={GENDER_COLORS}
          id="gender"
          percentages={genderPercentages}
          setActivePieSliceIndex={i => setActiveGender(i)}
        />
        <DEIPageLegend
          colors={GENDER_COLORS}
          filterLegend
          onHoverType={i => setActiveGender(i)}
          types={genderPercentages}
        />
      </DEIPageDonutChartsChartWrapperDIV>
    </DEIPageDonutChartsDIV>
  )
}

export default DEIPageDonutCharts
